import { useState } from 'react'

interface TagInputProps {
  value: (string | number)[]
  onChange: (value: (string | number)[]) => void
  disabled?: boolean
  placeholder?: string
}

export function TagInput({ value, onChange, disabled, placeholder }: TagInputProps) {
  const [inputValue, setInputValue] = useState('')

  const addTag = () => {
    const trimmed = inputValue.trim()
    if (!trimmed) return

    const numValue = Number(trimmed)
    const newValue = isNaN(numValue) ? trimmed : numValue

    const isDuplicate = value.some(item => {
      if (item === newValue) return true
      if (typeof item === 'number' && typeof newValue === 'string') {
        return item === Number(newValue)
      }
      if (typeof item === 'string' && typeof newValue === 'number') {
        return Number(item) === newValue
      }
      return false
    })

    if (!isDuplicate) {
      onChange([...value, newValue])
    }
    setInputValue('')
  }

  const removeTag = (index: number) => {
    onChange(value.filter((_, i) => i !== index))
  }

  return (
    <div className={`flex flex-wrap gap-1.5 p-2 border border-gray-300 rounded-lg min-h-[38px] ${disabled ? 'opacity-50 cursor-not-allowed bg-gray-50' : 'bg-white'}`}>
      {value.map((item, idx) => (
        <span key={idx} className="inline-flex items-center gap-1 px-2 py-0.5 bg-indigo-50 text-indigo-700 text-sm rounded">
          {String(item)}
          {!disabled && (
            <button type="button" onClick={() => removeTag(idx)} className="text-indigo-500 hover:text-indigo-700 text-base leading-none">&times;</button>
          )}
        </span>
      ))}
      {!disabled && (
        <input
          type="text"
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addTag() } }}
          placeholder={value.length === 0 ? (placeholder || 'Wert hinzufuegen...') : ''}
          className="flex-1 min-w-[120px] px-2 py-0.5 text-sm border-none focus:ring-0 focus:outline-none bg-transparent"
        />
      )}
    </div>
  )
}
